var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vl-layout"},[_c('vl-nav'),_c('div',{staticClass:"vl-layout__main"},[_c('LeftSide'),_c('Main'),_c('RightSide')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }